import { TLF_BUNDLE_CHUNK_SIZE_BYTES } from "./interface";

/**
 * Split a compressed bundle into upload chunks no larger than 2 MB.
 *
 * @param bundle - Compressed bundle contents
 * @returns Ordered Blob chunks; an empty bundle produces no chunks
 */
export const splitBundleChunks = (bundle: Blob): Blob[] => {
  const chunks: Blob[] = [];
  for (let offset = 0; offset < bundle.size; offset += TLF_BUNDLE_CHUNK_SIZE_BYTES) {
    chunks.push(bundle.slice(offset, offset + TLF_BUNDLE_CHUNK_SIZE_BYTES));
  }
  return chunks;
};
